import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController } from '@ionic/angular/lazy';
import { QuoteService } from 'src/app/services/quote.service';
import { PersonPickerPage } from 'src/app/modals/person-picker/person-picker.page';
import { OrganisationService } from 'src/app/services/organisation.service';
import { OrganisationPickerPage } from 'src/app/modals/organisation-picker/organisation-picker.page';
import { ObserverService } from 'src/app/services/observer.service';
import { PricingTierService } from 'src/app/services/pricing-tier.service';
import { TaxZoneService } from 'src/app/services/tax-zone.service';
import { SupportedCurrencyService } from 'src/app/services/supported-currency.service';
import { DateTimePickerPage } from 'src/app/modals/date-time-picker/date-time-picker.page';
import { ConnectedAccountService } from 'src/app/services/connected-account.service';
import { UserService } from 'src/app/services/user.service';
import { StorageService } from 'src/app/services/storage.service';
import { CountryService } from 'src/app/services/country.service';
import { CountryPickerPage } from 'src/app/modals/country-picker/country-picker.page';
import moment from 'moment-timezone';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-quote-edit',
    templateUrl: './quote-edit.page.html',
    styleUrls: ['./quote-edit.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class QuoteEditPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    moment = moment;
    params = {};
    user = null;
    @Input() quote_id = null;
    quote = null;
    person_name = null;
    organisation = null;
    pricing_tiers = null;
    tax_zones = null;
    formatted_expiry_date = null;
    formatted_sent_date = null;
    formatted_declined_date = null;
    formatted_accepted_date = null;
    formatted_cancelled_date = null;
    modal_css_class = '';
    date_modal_css_class = '';
    countries = null;
    country = null;
    subdivisions = null;
    address_requires_first_name = true;
    address_requires_last_name = true;
    address_requires_line_1 = true;
    address_requires_locality = true;
    address_requires_subdivision = false;
    address_subdivision_label = "State / province / region / county";
    address_subdivision_label_changed = false;
    address_requires_postal_code = false;
    address_postal_code_label = "Postcode";
    address_requires_mobile_phone_number = true;

    order_pos_shipping_address_require_subdivision = true;
    order_pos_shipping_address_require_postal_code = true;

    // modal flags
    person_picker_modal_open = false;
    organisation_picker_modal_open = false;
    date_picker_modal_open = false;
    country_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public loadingController: LoadingController,
        public alertController: AlertController,
        private organisationService: OrganisationService,
        private quoteService: QuoteService,
        private observerService: ObserverService,
        private pricingTierService: PricingTierService,
        private taxZoneService: TaxZoneService,
        private supportedCurrencyService: SupportedCurrencyService,
        private connectedAccountService: ConnectedAccountService,
        private userService: UserService,
        private storageService: StorageService,
        private countryService: CountryService,
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
            this.date_modal_css_class = 'backdrop';
        }

        if(this.quote_id) {


            this.loadData().then(() => {

                this.storageService.get('order_pos_shipping_address_require_first_name').then((order_pos_shipping_address_require_first_name) => {
                    if(order_pos_shipping_address_require_first_name) {

                        if(order_pos_shipping_address_require_first_name === 'true') {
                            this.address_requires_first_name = true;
                        } 
                        else {
                            this.address_requires_first_name = false;
                        }

                    }
                });

                this.storageService.get('order_pos_shipping_address_require_last_name').then((order_pos_shipping_address_require_last_name) => {
                    if(order_pos_shipping_address_require_last_name) {

                        if(order_pos_shipping_address_require_last_name === 'true') {
                            this.address_requires_last_name = true;
                        } 
                        else {
                            this.address_requires_last_name = false;
                        }

                    }
                });

                this.storageService.get('order_pos_shipping_address_require_line_1').then((order_pos_shipping_address_require_line_1) => {
                    if(order_pos_shipping_address_require_line_1) {

                        if(order_pos_shipping_address_require_line_1 === 'true') {
                            this.address_requires_line_1 = true;
                        } 
                        else {
                            this.address_requires_line_1 = false;
                        }

                    }
                });

                this.storageService.get('order_pos_shipping_address_require_locality').then((order_pos_shipping_address_require_locality) => {
                    if(order_pos_shipping_address_require_locality) {

                        if(order_pos_shipping_address_require_locality === 'true') {
                            this.address_requires_locality = true;
                        } 
                        else {
                            this.address_requires_locality = false;
                        }

                    }
                });

                this.storageService.get('order_pos_shipping_address_require_subdivision').then((order_pos_shipping_address_require_subdivision) => {
                    if(order_pos_shipping_address_require_subdivision) {

                        if(order_pos_shipping_address_require_subdivision === 'true') {
                            this.order_pos_shipping_address_require_subdivision = true;
                        } 
                        else {
                            this.order_pos_shipping_address_require_subdivision = false;
                        }

                    }
                });

                this.storageService.get('order_pos_shipping_address_require_postal_code').then((order_pos_shipping_address_require_postal_code) => {
                    if(order_pos_shipping_address_require_postal_code) {

                        if(order_pos_shipping_address_require_postal_code === 'true') {
                            this.order_pos_shipping_address_require_postal_code = true;
                        } 
                        else {
                            this.order_pos_shipping_address_require_postal_code = false;
                        }

                    }
                });

                this.storageService.get('order_pos_shipping_address_require_mobile_phone_number').then((order_pos_shipping_address_require_mobile_phone_number) => {
                    if(order_pos_shipping_address_require_mobile_phone_number) {

                        if(order_pos_shipping_address_require_mobile_phone_number === 'true') {
                            this.address_requires_mobile_phone_number = true;
                        } 
                        else {
                            this.address_requires_mobile_phone_number = false;
                        }

                    }
                });

                this.params['person_id'] = "";
                this.params['organisation_id'] = "";
                this.params["reference"] = "";
                this.params['pricing_tier_id'] = "";
                this.params['tax_zone_id'] = "";
                this.params['expiry_date'] = "";
                this.params['sent_date'] = "";
                this.params['declined_date'] = "";
                this.params['accepted_date'] = "";
                this.params['cancelled_date'] = "";
                this.params['shipping_address_first_name'] = "";
                this.params['shipping_address_last_name'] = "";
                this.params['shipping_address_organisation_title'] = "";
                this.params['shipping_address_premises'] = "";
                this.params['shipping_address_line_1'] = "";
                this.params['shipping_address_line_2'] = "";
                this.params['shipping_address_locality'] = "";
                this.params['shipping_address_subdivision'] = "";
                this.params['shipping_address_postal_code'] = "";
                this.params['shipping_address_country_id'] = "";
                this.params['shipping_address_mobile_phone_number'] = "";
                this.params['shipping_address_what3words_address'] = "";
                this.params['shipping_address_courier_instructions'] = "";
                this.params['shipping_notification_email_address'] = "";
                this.params["special_instructions"] = "";
                this.params['customer_note'] = "";
                this.params['internal_note'] = "";

                if(this.quote.person) {

                    this.params['person_id'] = this.quote.person.id;

                    // format person name for picker UI
                    if(this.quote.person.full_name) {
                        this.person_name = this.quote.person.full_name + ' (#' + this.quote.person.number + ')';
                    }
                    else {
                        this.person_name = '#' + this.quote.person.number;
                    }

                }

                if(this.quote.organisation) {
                    this.params['organisation_id'] = this.quote.organisation.id;
                    this.organisation = this.quote.organisation;
                }

                if(this.quote.reference) {
                    this.params["reference"] = this.quote.reference;
                }

                if(this.quote.pricing_tier && this.quote.pricing_tier.id) {
                    this.params['pricing_tier_id'] = this.quote.pricing_tier.id;
                }

                if(this.quote.tax_zone && this.quote.tax_zone.id) {
                    this.params['tax_zone_id'] = this.quote.tax_zone.id;
                }

                if(this.quote.expiry_date) {
                    this.params['expiry_date'] = this.moment.utc(this.quote.expiry_date).tz(this.user.timezone.code).toISOString(true);
                    this.formatted_expiry_date = this.moment(this.params['expiry_date']).format("D MMM YYYY, HH:mm");
                }

                if(this.quote.sent_date) {
                    this.params['sent_date'] = this.moment.utc(this.quote.sent_date).tz(this.user.timezone.code).toISOString(true);
                    this.formatted_sent_date = this.moment(this.params['sent_date']).format("D MMM YYYY, HH:mm");
                }

                if(this.quote.declined_date) {
                    this.params['declined_date'] = this.moment.utc(this.quote.declined_date).tz(this.user.timezone.code).toISOString(true);
                    this.formatted_declined_date = this.moment(this.params['declined_date']).format("D MMM YYYY, HH:mm");
                }

                if(this.quote.accepted_date) {
                    this.params['accepted_date'] = this.moment.utc(this.quote.accepted_date).tz(this.user.timezone.code).toISOString(true);
                    this.formatted_accepted_date = this.moment(this.params['accepted_date']).format("D MMM YYYY, HH:mm");
                }

                if(this.quote.cancelled_date) {
                    this.params['cancelled_date'] = this.moment.utc(this.quote.cancelled_date).tz(this.user.timezone.code).toISOString(true);
                    this.formatted_cancelled_date = this.moment(this.params['cancelled_date']).format("D MMM YYYY, HH:mm");
                }

                if(this.quote.shipping_address) {

                    if(this.quote.shipping_address.first_name) {
                        this.params['shipping_address_first_name'] = this.quote.shipping_address.first_name;
                    }
                    if(this.quote.shipping_address.last_name) {
                        this.params['shipping_address_last_name'] = this.quote.shipping_address.last_name;
                    }
                    if(this.quote.shipping_address.organisation_title) {
                        this.params['shipping_address_organisation_title'] = this.quote.shipping_address.organisation_title;
                    }
                    if(this.quote.shipping_address.premises) {
                        this.params['shipping_address_premises'] = this.quote.shipping_address.premises;
                    }
                    if(this.quote.shipping_address.line_1) {
                        this.params['shipping_address_line_1'] = this.quote.shipping_address.line_1;
                    }
                    if(this.quote.shipping_address.line_2) {
                        this.params['shipping_address_line_2'] = this.quote.shipping_address.line_2;
                    }
                    if(this.quote.shipping_address.locality) {
                        this.params['shipping_address_locality'] = this.quote.shipping_address.locality;
                    }
                    if(this.quote.shipping_address.subdivision) {
                        this.params['shipping_address_subdivision'] = this.quote.shipping_address.subdivision;
                    }
                    if(this.quote.shipping_address.postal_code) {
                        this.params['shipping_address_postal_code'] = this.quote.shipping_address.postal_code;
                    }

                    if(this.quote.shipping_address.country) {
                        this.params['shipping_address_country_id'] = this.quote.shipping_address.country.id;
                        this.loadCountry(this.quote.shipping_address.country.id).then(() => {
                            this.countryChanged();
                        })
                        .catch(() => { });
                    }

                    if(this.quote.shipping_address.mobile_phone_number) {
                        this.params['shipping_address_mobile_phone_number'] = this.quote.shipping_address.mobile_phone_number;
                    }

                    if(this.quote.shipping_address.what3words_address) {
                        this.params['shipping_address_what3words_address'] = this.quote.shipping_address.what3words_address;
                    }

                    if(this.quote.shipping_address.courier_instructions) {
                        this.params['shipping_address_courier_instructions'] = this.quote.shipping_address.courier_instructions;
                    }

                }

                if(this.quote.shipping_notification_email_address) {
                    this.params['shipping_notification_email_address'] = this.quote.shipping_notification_email_address;
                }

                if(this.quote.special_instructions) {
                    this.params["special_instructions"] = this.quote.special_instructions;
                }

                if(this.quote.customer_note) {
                    this.params['customer_note'] = this.quote.customer_note;
                }

                if(this.quote.internal_note) {
                    this.params['internal_note'] = this.quote.internal_note;
                }

            })
            .catch(() => { });

        }

        this.observerService.subscribe('pricing_tier_added|quote_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                pricing_tiers.push(pricing_tier);
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tier_deleted|quote_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                for(let i = 0; i < pricing_tiers.length; i++) {
                    if(pricing_tiers[i].id === pricing_tier["id"]) {
                        pricing_tiers.splice(i, 1);
                        break;
                    }
                }
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tier_updated|quote_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                for(let i = 0; i < pricing_tiers.length; i++) {
                    if(pricing_tiers[i].id === pricing_tier["id"]) {
                        pricing_tiers[i] = pricing_tier;
                        break;
                    }
                }
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tiers_changed|quote_edit_modal', (pricing_tiers) => {
            if(pricing_tiers) {
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('tax_zone_added|quote_edit_modal', (tax_zone) => {
            if(tax_zone) {
                let tax_zones = this.tax_zones;
                tax_zones.push(tax_zone);
                this.sortTaxZones(tax_zones);
            }
        });

        this.observerService.subscribe('tax_zone_deleted|quote_edit_modal', (tax_zone) => {
            if(tax_zone) {
                let tax_zones = this.tax_zones;
                for(let i = 0; i < tax_zones.length; i++) {
                    if(tax_zones[i].id === tax_zone["id"]) {
                        tax_zones.splice(i, 1);
                        break;
                    }
                }
                this.sortTaxZones(tax_zones);
            }
        });

        this.observerService.subscribe('tax_zone_updated|quote_edit_modal', (tax_zone) => {
            if(tax_zone) {
                let tax_zones = this.tax_zones;
                for(let i = 0; i < tax_zones.length; i++) {
                    if(tax_zones[i].id === tax_zone["id"]) {
                        tax_zones[i] = tax_zone;
                        break;
                    }
                }
                this.sortTaxZones(tax_zones);
            }
        });

        this.observerService.subscribe('tax_zones_changed|quote_edit_modal', (tax_zones) => {
            if(tax_zones) {
                this.sortTaxZones(tax_zones);
            }
        });

    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading quote").then(() => {
                this.loadQuote().then(() => {
                    this.loading_spinner.message = "Loading user";
                    this.loadUser().then(() => {
                        this.loading_spinner.message = "Loading pricing tiers";
                        this.loadPricingTiers().then(() => {
                            this.loading_spinner.message = "Loading tax zones";
                            this.loadTaxZones().then(() => {
                                this.loading_spinner.dismiss();
                                resolve();
                            })
                            .catch(() => {
                                this.loading_spinner.dismiss();
                                reject();
                            });
                        })
                        .catch(() => {
                            this.loading_spinner.dismiss();
                            reject();
                        });
                    })
                    .catch(() => {
                        this.loading_spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    ngOnDestroy() {
        this.observerService.destroy("pricing_tier_added|quote_edit_modal");
        this.observerService.destroy("pricing_tier_updated|quote_edit_modal");
		this.observerService.destroy("pricing_tier_deleted|quote_edit_modal");
        this.observerService.destroy("pricing_tiers_changed|quote_edit_modal");
        this.observerService.destroy("tax_zone_added|quote_edit_modal");
        this.observerService.destroy("tax_zone_updated|quote_edit_modal");
        this.observerService.destroy("tax_zone_deleted|quote_edit_modal");
        this.observerService.destroy("tax_zones_changed|quote_edit_modal");
    }

    loadQuote() {
        return new Promise<void>((resolve, reject) => {
            this.quote = null;
            this.quoteService.getQuote(this.quote_id).then((quote) => {
                if(quote) {
                    this.quote = quote;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    loadPricingTiers() {
        return new Promise<void>((resolve, reject) => {
            this.pricing_tiers = [];
            this.pricingTierService.getPricingTiers().then((pricing_tiers) => {
                if(pricing_tiers) {
                    this.sortPricingTiers(pricing_tiers);
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    sortPricingTiers(pricing_tiers) {
        pricing_tiers.sort((a, b) => {
            if(a['order'] < b['order']) { return -1; }
            if(a['order'] > b['order']) { return 1; }
            return 0;
        });
        this.pricing_tiers = pricing_tiers;
    }

    loadTaxZones() {
        return new Promise<void>((resolve, reject) => {
            this.tax_zones = [];
            this.taxZoneService.getTaxZones().then((tax_zones) => {
                if(tax_zones) {
                    this.sortTaxZones(tax_zones);
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    sortTaxZones(tax_zones) {
        tax_zones.sort((a, b) => {
            if (a.country.order < b.country.order) { return -1; }
            if (a.country.order > b.country.order) { return 1; }
            return 0;
        });
        this.tax_zones = tax_zones;
    }

    loadUser() {
        return new Promise<void>((resolve, reject) => {
            this.user = null;
            this.storageService.get("connected_account_id").then((connected_account_id) => {
                if(connected_account_id) {
                    this.connectedAccountService.getConnectedAccount(connected_account_id).then((connected_account) => {
                        if(connected_account['user_id']) {
                            this.userService.getUser(connected_account['user_id']).then((user) => {
                                this.user = user;
                                resolve();
                            })
                            .catch(() => {
                                reject();
                            });
                        }
                    })
                    .catch(() => {
                        reject();
                    });
                }
            })
            .catch(() => {
                reject();
            });
        });
    }

    loadCountry(country_id) {
        const promise = new Promise<void>((resolve, reject) => {
            this.country = null;
            this.subdivisions = null;
            this.countryService.getCountry(country_id).then((country: any) => {
                this.country = country;
                if(country.subdivisions) {
                    this.subdivisions = country.subdivisions;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
        return promise;
    }

    countryChanged(){

        this.address_subdivision_label = "State / province / region / county";
        this.address_requires_subdivision = false;
        this.address_postal_code_label = "Postcode";
        this.address_requires_postal_code = false;

        if(this.params['shipping_address_country_id']) {

            if(this.country.subdivision_name) {
                this.address_subdivision_label = this.country.subdivision_name;
            }

            if(this.order_pos_shipping_address_require_subdivision && this.subdivisions && this.subdivisions.length != 0) {
                this.address_requires_subdivision = true;
            }

            if(this.country.postal_code_name) {
                this.address_postal_code_label = this.country.postal_code_name;
            }

            if(this.order_pos_shipping_address_require_postal_code && this.country.postal_code_required == true) {
                this.address_requires_postal_code = true;
            }

        }

        // NOTE: address_subdivision_label_changed is used to force UI to render correctly
        this.address_subdivision_label_changed = false;

        setTimeout(() => {
            this.address_subdivision_label_changed = true;
        }, 0);

    }

    close() {
        this.modalController.dismiss();
    }

    async update() {

        let validated = true;
        let email_address_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let parsed_what3words_address = null;

        // NOTE: if any parts of the shipping address are provided then validate
        if(this.params['shipping_address_first_name'] || this.params['shipping_address_last_name'] || this.params['shipping_address_organisation_title'] || this.params['shipping_address_country_id'] || this.params['shipping_address_premises'] || this.params['shipping_address_line_1'] || this.params['shipping_address_line_2'] || this.params['shipping_address_locality'] || this.params['shipping_address_subdivision'] || this.params['shipping_address_postal_code'] ||  this.params['shipping_address_what3words_address'] || this.params['shipping_address_courier_instructions'] || this.params['shipping_address_mobile_phone_number']) {
            
            if(this.params['shipping_address_what3words_address'] != null) {

                parsed_what3words_address = this.params['shipping_address_what3words_address'].trim();

                if(parsed_what3words_address.startsWith("///")) {
                    parsed_what3words_address = parsed_what3words_address.substring(3);
                }
                else if(parsed_what3words_address.toLowerCase().indexOf("what3words.com/") !== -1) {
                    parsed_what3words_address = parsed_what3words_address.replace(/https?:\/\/(?:www\.)?what3words\.com\/([a-z]+\.[a-z]+\.[a-z]+).*/i, "$1");
                }

            }

            if(this.address_requires_first_name && (this.params['shipping_address_first_name'] == null || this.params['shipping_address_first_name'].trim() === "")) {
                this.presentAlert("Missing first name", "Please enter a shipping address first name.");
                validated = false;
            }
            else if(this.address_requires_last_name && (this.params['shipping_address_last_name'] == null || this.params['shipping_address_last_name'].trim() === "")) {
                this.presentAlert("Missing last name", "Please enter a shipping address last name.");
                validated = false;
            }
            else if(this.params['shipping_address_country_id'] == null || this.params['shipping_address_country_id'].trim() === "") {
                this.presentAlert("Missing country", "Please select a shipping address country.");
                validated = false;
            }
            else {

                if(this.address_requires_line_1 && (this.params['shipping_address_line_1'] == null || this.params['shipping_address_line_1'].trim() === "")) {
                    this.presentAlert("Missing line 1", "Please enter a shipping address line 1.");
                    validated = false;
                }
                else if(this.address_requires_locality && (this.params['shipping_address_locality'] == null || this.params['shipping_address_locality'].trim() === "")) {
                    this.presentAlert("Missing town / city", "Please enter a shipping address town / city.");
                    validated = false;
                }
                else if(this.address_requires_subdivision && (this.params['shipping_address_subdivision'] == null || this.params['shipping_address_subdivision'].trim() === "")) {
                    this.presentAlert("Missing " + this.address_subdivision_label, "Please enter a shipping address " + this.address_subdivision_label + ".");
                    validated = false;
                }
                else if(this.address_requires_postal_code && (this.params['shipping_address_postal_code'] == null || this.params['shipping_address_postal_code'].trim() === "")) {
                    this.presentAlert("Missing " + this.address_postal_code_label, "Please enter a shipping address " + this.address_postal_code_label + ".");
                    validated = false;
                }
                else if(parsed_what3words_address !== "" && !/^[a-z]+\.[a-z]+\.[a-z]+$/i.test(parsed_what3words_address)) {
                    this.presentAlert("Invalid what3words address", "Please enter a valid shipping address what3words address.");
                    validated = false;
                }
                else if(this.address_requires_mobile_phone_number && (this.params['shipping_address_mobile_phone_number'] == null || this.params['shipping_address_mobile_phone_number'].trim() === "")) {
                    this.presentAlert("Missing mobile phone number", "Please enter a shipping address mobile phone number.");
                    validated = false;
                }

            }
        }

        if(this.params['shipping_notification_email_address'] && !email_address_regex.test(String(this.params['shipping_notification_email_address']).toLowerCase())) {
            this.presentAlert("Invalid shipping notification email address", "Please enter a valid shipping notification email address.");
            validated = false;
        }

        if(validated) {

            if(this.params['expiry_date']) {
                this.params['expiry_date'] = this.moment(this.params['expiry_date']).utc().toISOString();
            }

            if(this.params['sent_date']) {
                this.params['sent_date'] = this.moment(this.params['sent_date']).utc().toISOString();
            }

            if(this.params['declined_date']) {
                this.params['declined_date'] = this.moment(this.params['declined_date']).utc().toISOString();
            }

            if(this.params['accepted_date']) {
                this.params['accepted_date'] = this.moment(this.params['accepted_date']).utc().toISOString();
            }

            if(this.params['cancelled_date']) {
                this.params['cancelled_date'] = this.moment(this.params['cancelled_date']).utc().toISOString();
            }

            if(parsed_what3words_address != null) {
                this.params['shipping_address_what3words_address'] = parsed_what3words_address;
            }

            this.updateQuote().then(() => {
                this.modalController.dismiss();
            });

        }

    }

    updateQuote() {
        return new Promise<void>((resolve, reject) => {
            this.presentSpinner("Updating quote").then(() => {
                this.quoteService.updateQuote(this.quote.id, this.params).then(() => {
                    this.spinner.dismiss();
                    resolve();
                })
                .catch(() => {
                    this.spinner.dismiss();
                    reject();
                });
            });
        });
    }

    async presentPersonPickerModal() {
        if(!this.person_picker_modal_open) {
            this.person_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: PersonPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    invoked_from: "quote_edit_modal",
                    person_id: (this.params['person_id'] ? this.params['person_id'] : null)
                }
            });
            modal.onDidDismiss().then((data) => {
                this.person_picker_modal_open = false;
                if(data.data) {
                    if(data.data['picker_action'] == "person_deleted") {
                        this.params['person_id'] = ""
                        this.person_name = null;
                    } 
                    else {
                        this.params['person_id'] = data.data['person_id'];
                        this.person_name = data.data['person_name'];
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentOrganisationPickerModal() {
        if(!this.organisation_picker_modal_open) {
            this.organisation_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: OrganisationPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    organisation_id: (this.params['organisation_id'] ? this.params['organisation_id'] : null)
                }
            });
            modal.onDidDismiss().then((data) => {
                this.organisation_picker_modal_open = false;
                if(data.data) {
                    if(data.data['picker_action'] == "organisation_deleted") {
                        this.params['organisation_id'] = ""
                        this.organisation = null;
                    } 
                    else {
                        this.params['organisation_id'] = data.data['organisation_id'];
                        this.organisationService.getOrganisation(data.data['organisation_id'],{}).then((organisation) => {
                            if(organisation) {
                                this.organisation = organisation;
                            }
                        })
                        .catch(() => { });
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentExpiryDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.params['expiry_date'] ? this.params['expiry_date'] : ""),
                    format: "date-time",
                    clear_date: true
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "date_deleted") {
                        this.params['expiry_date'] = "";
                        this.formatted_expiry_date = null;
                    }
                    else {
                        this.params['expiry_date'] = data.data['date'];
                        this.formatted_expiry_date = this.moment(this.params['expiry_date']).format("D MMM YYYY, HH:mm");
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentSentDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.params['sent_date'] ? this.params['sent_date'] : ""),
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.params['sent_date'] = data.data['date'];
                    this.formatted_sent_date = this.moment(this.params['sent_date']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentDeclinedDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.params['declined_date'] ? this.params['declined_date'] : ""),
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.params['declined_date'] = data.data['date'];
                    this.formatted_declined_date = this.moment(this.params['declined_date']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAcceptedDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.params['accepted_date'] ? this.params['accepted_date'] : ""),
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.params['accepted_date'] = data.data['date'];
                    this.formatted_accepted_date = this.moment(this.params['accepted_date']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentCancelledDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.params['cancelled_date'] ? this.params['cancelled_date'] : ""),
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.params['cancelled_date'] = data.data['date'];
                    this.formatted_cancelled_date = this.moment(this.params['cancelled_date']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentCountryPickerModal() {
        if(!this.country_picker_modal_open) {
            this.country_picker_modal_open = true;
            let existing_shipping_address_country_id = "";
            if(this.params['shipping_address_country_id']) {
                existing_shipping_address_country_id = this.params['shipping_address_country_id'];
            }
            const modal = await this.modalController.create({
                component: CountryPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    country_id: (this.params['shipping_address_country_id'] ? this.params['shipping_address_country_id'] : "")
                }
            });
            modal.onDidDismiss().then((data) => {
                this.country_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "country_deleted") {
                        this.params['shipping_address_premises'] = "";
                        this.params['shipping_address_line_1'] = "";
                        this.params['shipping_address_line_2'] = "";
                        this.params['shipping_address_locality'] = "";
                        this.params['shipping_address_subdivision'] = "";
                        this.params['shipping_address_postal_code'] = "";
                        this.params['shipping_address_country_id'] = "";
                        this.country = null;
                        this.countryChanged();
                    }
                    else {
                        if(data.data['country_id'] != existing_shipping_address_country_id) {
                            this.params["shipping_address_country_id"] = data.data['country_id'];
                            this.loadCountry(data.data['country_id']).then(() => {
                                this.countryChanged();
                            })
                            .catch(() => { });
                        }
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}